import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import InlineEditor from 'ckeditor5-custom-build';
import config from "../../config";

//import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

import './styles.css';

const styles = {
  container: {
    fontSize: '13px',
    cursor: 'text',
  },
};


//InlineEditor.extraPlugins = [ MyCustomUploadAdapterPlugin ];

const Editor = (props) => {
  const { content, style: propsStyle, setContent, ...restProps } = props;
  const custom_config = {
   extraPlugins:[MyCustomUploadAdapterPlugin],
  /* toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'blockQuote',
        'insertTable',
        '|',
        'imageUpload',
        'undo',
        'redo'
      ]
    },*/
   
    placeholder: "** Editable Text **"
  }
  return (
    <div {...restProps} style={{ ...styles.container, ...propsStyle }}>
      <CKEditor
        onChange={(event, editor) => {
          // eslint-disable-next-line no-unused-expressions
          setContent?.(editor.getData());
        }}
       config={ custom_config}
        editor={InlineEditor}
        data={content ? content : ''}
      />
    </div>
  );
};
function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader)
  }
}

class MyUploadAdapter {
  constructor(props) {
      // CKEditor 5's FileLoader instance.
    this.loader = props;
    // URL where to send files.
    this.url = config.API_URL + `uploadEditor`;
  }

  // Starts the upload process.
  upload() {
      return new Promise((resolve, reject) => {
          this._initRequest();
          this._initListeners(resolve, reject);
          this._sendRequest();
      } );
  }

  // Aborts the upload process.
  abort() {
      if ( this.xhr ) {
          this.xhr.abort();
      }
  }

  // Example implementation using XMLHttpRequest.
  _initRequest() {
      const xhr = this.xhr = new XMLHttpRequest();

      xhr.open('POST', this.url, true);
      xhr.responseType = 'json';
      xhr.setRequestHeader('Access-Control-Allow-Origin', '*')
      //xhr.setRequestHeader('Authorization', getToken())
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners( resolve, reject ) {
      const xhr = this.xhr;
      const loader = this.loader;
      const genericErrorText = 'Couldn\'t upload file:' + ` ${ loader.file.name }.`;

      xhr.addEventListener( 'error', () => reject( genericErrorText ) );
      xhr.addEventListener( 'abort', () => reject() );
      xhr.addEventListener( 'load', () => {
          const response = xhr.response;
          if ( !response || response.error ) {
              return reject( response && response.error ? response.error.message : genericErrorText );
          }

          // If the upload is successful, resolve the upload promise with an object containing
          // at least the "default" URL, pointing to the image on the server.
          console.log(response.result)
          resolve({
              default: response.result.location
          });
      } );

      if ( xhr.upload ) {
          xhr.upload.addEventListener( 'progress', evt => {
              if ( evt.lengthComputable ) {
                  loader.uploadTotal = evt.total;
                  loader.uploaded = evt.loaded;
              }
          } );
      }
  }

  // Prepares the data and sends the request.
   _sendRequest() {
      const data = new FormData();

      this.loader.file.then(result => {
        data.append('file', result);
        this.xhr.send(data);
      
        }
      )


  }

}


export default Editor;
